'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import BaseCard from '@/components/BaseCard';
import CardAwards from '@/components/BaseCard/CardAwards';
import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from './style.module.scss';
interface Props {
  caseItem: CaseSlideItem;
  className?: string;
  setIsCustomCursorVisible?: (value: boolean) => void;
}
const WorkCard: FC<Props> = t0 => {
  const $ = _c(21);
  const {
    caseItem,
    className,
    setIsCustomCursorVisible
  } = t0;
  let t1;
  if ($[0] !== setIsCustomCursorVisible) {
    t1 = () => {
      setIsCustomCursorVisible?.(true);
    };
    $[0] = setIsCustomCursorVisible;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onMouseEnter = t1;
  let t2;
  if ($[2] !== setIsCustomCursorVisible) {
    t2 = () => {
      setIsCustomCursorVisible?.(false);
    };
    $[2] = setIsCustomCursorVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onMouseLeave = t2;
  const t3 = caseItem.url || "";
  let t4;
  if ($[4] !== className) {
    t4 = clsx(css.workCard, className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = caseItem.image?.url;
  let t6;
  if ($[6] !== caseItem.awards) {
    t6 = <CardAwards awards={caseItem.awards} />;
    $[6] = caseItem.awards;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== caseItem.title) {
    t7 = caseItem.title ? <Typography variant="h6" tag="h3" className={css.title}><StrapiRichContent content={caseItem.title} /></Typography> : null;
    $[8] = caseItem.title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== caseItem.subtitle || $[11] !== caseItem.thumbnailUrl || $[12] !== caseItem.videoUrl || $[13] !== onMouseEnter || $[14] !== onMouseLeave || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <BaseCard playing={true} url={t3} className={t4} subtitle={caseItem.subtitle} videoUrl={caseItem.videoUrl} thumbnailUrl={caseItem.thumbnailUrl} imageUrl={t5} withOverlay={false} awards={t6} mainText={t7} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />;
    $[10] = caseItem.subtitle;
    $[11] = caseItem.thumbnailUrl;
    $[12] = caseItem.videoUrl;
    $[13] = onMouseEnter;
    $[14] = onMouseLeave;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default WorkCard;